module.exports = __webpack_public_path__ + "img/anex2016-min.631faf85.jpg";